class CartPage extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => this.onClick(event));
    this.addEventListener('change', (event) => this.onChange(event));
  }

  async onClick(event) {
    const quantityButton = event.target.closest('[data-cart-page-quantity-action]');
    if (quantityButton) {
      const line = quantityButton.closest('[data-cart-page-line]');
      const input = line?.querySelector('[data-cart-page-quantity-input]');
      if (!input) return;

      const current = Number(input.value);
      const increment = Number(input.step) || 1;
      const minimum = Number(input.dataset.minimum) || 1;
      const maximum = input.max ? Number(input.max) : Infinity;
      const requested = quantityButton.dataset.cartPageQuantityAction === 'increase'
        ? Math.min(maximum, current + increment)
        : (current <= minimum ? 0 : Math.max(minimum, current - increment));
      await this.updateLine(input, requested, quantityButton);
      return;
    }

    const removeLink = event.target.closest('[data-cart-page-remove]');
    if (removeLink) {
      event.preventDefault();
      await this.updateLine(removeLink, 0, removeLink);
    }
  }

  async onChange(event) {
    const input = event.target.closest('[data-cart-page-quantity-input]');
    if (!input) return;
    const requested = this.normalizedQuantity(input, Number(input.value));
    await this.updateLine(input, requested, input);
  }

  normalizedQuantity(input, quantity) {
    if (!Number.isFinite(quantity) || quantity <= 0) return 0;
    const minimum = Number(input.dataset.minimum) || 1;
    const increment = Number(input.step) || 1;
    const maximum = input.max ? Number(input.max) : Infinity;
    const stepped = minimum + (Math.round((quantity - minimum) / increment) * increment);
    return Math.min(maximum, Math.max(minimum, stepped));
  }

  async updateLine(source, quantity, loadingTarget) {
    const lineContainer = source.closest('[data-cart-page-line]');
    const line = Number(source.dataset.line || lineContainer?.dataset.cartPageLine);
    if (!line || !window.themeCart) return;

    loadingTarget.setAttribute('aria-busy', 'true');
    if ('disabled' in loadingTarget) loadingTarget.disabled = true;
    this.hideError();

    try {
      await window.themeCart.change(line, quantity, { openDrawer: false });
      await this.refresh();
      const status = document.getElementById('ThemeStatus');
      if (status) status.textContent = this.dataset.updatedMessage || '';
    } catch (error) {
      if (source.matches?.('[data-cart-page-quantity-input]')) source.value = source.defaultValue;
      this.showError(error.message || this.dataset.updateError);
    } finally {
      loadingTarget.removeAttribute('aria-busy');
      if ('disabled' in loadingTarget) loadingTarget.disabled = false;
    }
  }

  async refresh() {
    const response = await fetch(`${window.themeRoutes.cart}?section_id=${encodeURIComponent(this.dataset.sectionId)}`);
    if (!response.ok) throw new Error(this.dataset.updateError);
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.querySelector('[data-main-cart]');
    if (replacement) this.replaceWith(replacement);
  }

  hideError() {
    const error = this.querySelector('[data-cart-page-error]');
    if (error) error.hidden = true;
  }

  showError(message) {
    const error = this.querySelector('[data-cart-page-error]');
    const status = document.getElementById('ThemeStatus');
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
    if (status) status.textContent = message;
  }
}

if (!customElements.get('cart-page')) {
  customElements.define('cart-page', CartPage);
}
